import * as core from 'cw-ui-core';
import React from 'react';

const getDialog = (dialogID, props = null) => {
  switch (dialogID) {
    case 'WHEN_CHARGED':
      return (
        <core.AsyncComponent
          key={dialogID}
          {...props}
          loader={(cb) => {
            System.import('./components/ShoppingCart/WhenChargedDialog/WhenChargedDialogContainer')
              .then((component) => {
                cb(component);
              });
          }}
        />);
    case 'EMAIL_VERIFICATION':
      return (
        <core.AsyncComponent
          key={dialogID}
          {...props}
          loader={(cb) => {
            System.import('./components/ShoppingCart/EmailVerificationDialog/EmailVerificationDialogContainer')
              .then((component) => {
                cb(component);
              });
          }}
        />);     
    case 'COMPANY_NOT_VERIFIED':
    return (
      <core.AsyncComponent
        key={dialogID}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/CompanyNotVerifiedDialog/CompanyNotVerifiedDialogContainer')
            .then((component) => {
              cb(component);
            });
        }}
    />);   
    case 'REMOVE_CART_ITEM':
    return (
      <core.AsyncComponent
        key={dialogID}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/RemoveCartItemDialog/RemoveCartItemDialogContainer')
            .then((component) => {
              cb(component);
            });
        }}
    />);   
    case 'ACCESS_DENIED':
    return (
      <core.AsyncComponent
        key={dialogID}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/AccessDeniedDialog/AccessDeniedDialogContainer')
            .then((component) => {
              cb(component);
            });
        }}
    />);   
    case 'INVALID_CARD':
    return (
      <core.AsyncComponent
        key={dialogID}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/InvalidCardDialog/InvalidCardDialogContainer')
            .then((component) => {
              cb(component);
            });
        }}
    />);
    case 'PARTNER_CODE':
    return (
      <core.AsyncComponent
        key={dialogID}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/PartnerCodeDialog/PartnerCodeDialogContainer')
            .then((component) => {
              cb(component);
            });
        }}
    />);      
    case 'CURRENCY_MISMATCH':
    return (
      <core.AsyncComponent
        key={dialogID}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/CurrencyMismatchDialog/CurrencyMismatchDialogContainer')
            .then((component) => {
              cb(component);
            });
        }}
    />);     
    default:
      return core.getCoreDialog(dialogID, props);
  }
};

export default getDialog;


// WEBPACK FOOTER //
// ./src/DialogFactory.js